import { useEffect, useState } from 'react'

interface ExperienceDisplayProps {
  experience: number
  level: number
  nextLevelExp: number
}

/**
 * 経験値表示コンポーネント
 */
export default function ExperienceDisplay({ experience, level, nextLevelExp }: ExperienceDisplayProps) {
  const progressPercentage = (experience / nextLevelExp) * 100

  return (
    <div className="bg-white rounded-2xl shadow-md p-4 mb-4 border-2 border-gray-100">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-3">
          {/* アバターアイコン */}
          <div className="relative w-14 h-14 flex-shrink-0">
            <div className="w-full h-full rounded-full bg-gray-200 flex items-center justify-center shadow-md">
              <svg
                className="w-8 h-8 text-gray-600"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
              </svg>
            </div>
            {/* レベルバッジ */}
            <div className="absolute -bottom-1 -right-1 bg-main text-sub rounded-full w-auto min-w-7 h-7 px-1.5 flex items-center justify-center font-bold text-xs border-2 border-white shadow-sm">
              Lv.{level}
            </div>
          </div>
          <div>
            <p className="text-xs text-gray-600">経験値</p>
            <p className="text-xs font-bold text-gray-800">{experience.toLocaleString()} XP</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-xss text-gray-500">次のレベルまで</p>
          <p className="text-xss font-bold text-main">{(nextLevelExp - experience).toLocaleString()} XP</p>
        </div>
      </div>

      {/* 経験値バー */}
      <div className="relative w-full h-3 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="absolute top-0 left-0 h-full bg-main transition-all duration-500 ease-out"
          style={{ width: `${Math.min(progressPercentage, 100)}%` }}
        >
          <div className="absolute inset-0 bg-white opacity-20 animate-pulse" />
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-xs font-bold text-gray-700 drop-shadow-sm">{Math.floor(progressPercentage)}%</span>
        </div>
      </div>
    </div>
  )
}
